import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render() {
        return (
            <tarot-question>
                {this.renderInputOrQuestion()}
            </tarot-question>
        );
    }

    renderInputOrQuestion = () => {
        if (this.props.sample_interps) {
            return (
                <p class='subject-set'>Your Question: {this.props.subject || 'Unspoken'}</p>
            );
        }

        return (
            <input
              onFocus={this.clearQuestion}
              onBlur={this.captureQuestion}
              name='question'
              type='text'
              maxLength='140'
              placeholder={this.props.placeholder || 'Enter your question or subject here'}
              data-action='Type-Question'
              class={this.props.subject ? 'has-subject' : ''}
            />
        );
    }

    captureQuestion = (e) => {
        const question = e.target.value;
        this.props.captureQuestion(question);
    }

    clearQuestion = (e) => {
        e.target.value = '';
        e.target.classList.remove('subject');
    }
}

const mapStateToProps = (state) => ({
    subject: state['tarot-reading'].subject,
    sample_interps: state['tarot-reading'].sample_interps,
});

const mapDispatchToProps = (dispatch) => ({
    captureQuestion: (question) => dispatch({ type: 'tarot-reading:question', payload: question }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-readings/tarot-reading/question.js